import {Loader} from "@modules/rating/components/animation/animation.style";
export const  AnimationLoader = () => {
  return (
    <Loader>
      <span className="loader"></span>
    </Loader>
)
}
